'use strict';

jQuery(function ($) {

});
